/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudWireIcon20Solid = forwardRef('NetCloudWireIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3.89 5.265A5.502 5.502 0 0 1 14.15 4.002 5.5 5.5 0 0 1 14 15h-3v2h4a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2h4v-2H5.5a5 5 0 0 1-1.61-9.735Z" })));
});
